import _get from 'lodash/get';
import {
  ApiToken,
  ApiTokensQueryVariables,
  useApiTokensQuery,
} from 'graphql-common';
import { GetUrlParams } from '@lib/enums/urls';
import { ListQueryHookProps, ListQueryHookResult } from '../types';

export default function useApiTokensQueryHook({
  paginationParams,
  skip,
}: ListQueryHookProps): ListQueryHookResult<ApiToken> {
  const page = _get(paginationParams, GetUrlParams.Page);
  const perPage = _get(paginationParams, GetUrlParams.PerPage);
  const usersQueryVariables: ApiTokensQueryVariables = {
    page: Number(page),
    limit: Number(perPage),
  };
  const usersQuery = useApiTokensQuery({
    fetchPolicy: 'cache-and-network',
    variables: usersQueryVariables,
    skip,
  });

  const { loading, data, previousData, refetch, error } = usersQuery;
  const queryData = data || previousData;
  const firstLoading = loading && previousData === undefined;
  const collection = _get(queryData, 'data.collection', []) as ApiToken[];
  const metadata = _get(queryData, 'data.metadata');
  const totalCount = _get(metadata, 'totalCount', 0);
  const totalPages = _get(metadata, 'totalPages', 1);
  return {
    collection,
    error,
    firstLoading,
    loading,
    refetch,
    totalCount,
    totalPages,
  };
}
